import { render } from "./HeaderBackgroundSvgIcon.vue?vue&type=template&id=713dc08e"
import script from "./HeaderBackgroundSvgIcon.vue?vue&type=script&lang=js"
export * from "./HeaderBackgroundSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__